/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Tags_UpdatedInputs */

const en_dialog_tags_updated = /** @type {(inputs: Dialog_Tags_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Updated successfully`)
};

const es_dialog_tags_updated = /** @type {(inputs: Dialog_Tags_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizado exitosamente`)
};

/**
* | output |
* | --- |
* | "Updated successfully" |
*
* @param {Dialog_Tags_UpdatedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_tags_updated = /** @type {((inputs?: Dialog_Tags_UpdatedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Tags_UpdatedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_tags_updated(inputs)
	return en_dialog_tags_updated(inputs)
});